module.exports = __webpack_public_path__ + "static/plomberie2-70fb26a3b34dba6e432099bf361c680d.jpg";